import AccessTimeImage from "./ic_accesstime_56px.webp?jsx";
import CanaliImage from "./ic_canali_56px.webp?jsx";
import MovieImage from "./ic_movie_56px.webp?jsx";
import SerataImage from "./ic_serata_56px.webp?jsx";
import { SectionHeader } from "~/components/ui/SectionHeader";

type TVGuideType = "ora-in-onda" | "serata" | "lista-canali" | "film-in-tv";
type TVGuideInfo = {
  label: string;
  url: string;
};

const GUIDE_DATA: Record<TVGuideType, TVGuideInfo> = {
  "ora-in-onda": {
    label: "Ora in Onda",
    url: "/ora-in-onda/",
  },
  serata: {
    label: "Serata",
    url: "/serata/",
  },
  "lista-canali": {
    label: "Lista Canali",
    url: "/canali/",
  },
  "film-in-tv": {
    label: "Film in TV",
    url: "/film-in-tv/",
  },
};

const SidebarTVGuideItem = ({ type }: { type: TVGuideType }) => {
  let Icon = AccessTimeImage;
  switch (type) {
    case "serata":
      Icon = SerataImage;
      break;
    case "lista-canali":
      Icon = CanaliImage;
      break;
    case "film-in-tv":
      Icon = MovieImage;
  }

  return (
    <div class="sgtv-h-24 sgtv-rounded sgtv-border sgtv-border-neutral-300 sgtv-bg-stone-100 sgtv-shadow">
      <a
        href={GUIDE_DATA[type].url}
        class="sgtv-h-full sgtv-w-full sgtv-flex-col sgtv-items-center"
      >
        <div class="sgtv-relative sgtv-h-3/5">
          <Icon
            alt="Icona Guida TV"
            class="sgtv-absolute sgtv-bottom-1 sgtv-left-0 sgtv-right-0 sgtv-mx-auto sgtv-mb-0 sgtv-mt-auto sgtv-h-10 sgtv-w-10"
          />
        </div>
        <p class="sgtv-h-2/5 sgtv-truncate sgtv-text-nowrap sgtv-text-center sgtv-font-roboto sgtv-text-xl md:sgtv-text-base xl:sgtv-text-xl">
          {GUIDE_DATA[type].label}
        </p>
      </a>
    </div>
  );
};

export const SidebarTVGuide = () => {
  return (
    <div class="sgtv-flex sgtv-flex-col sgtv-gap-6">
      <SectionHeader as="span" label="Guida Tv" />
      <div class="sgtv-grid sgtv-grid-cols-2 sgtv-grid-rows-2 sgtv-gap-4">
        <SidebarTVGuideItem type="ora-in-onda" />
        <SidebarTVGuideItem type="serata" />
        <SidebarTVGuideItem type="lista-canali" />
        <SidebarTVGuideItem type="film-in-tv" />
      </div>
    </div>
  );
};
